import {Card, Grid, Tooltip} from '@mui/material'
import {useDatxPathGenerator} from '../../../../util/routing'
import {ROUTES} from '../../../../constants/routing'
import {Link, useSearchParams} from 'react-router-dom'
import {getPathToClassification} from '../../../../util/classifications/Classification'
import {SidebarClassificationNode} from '../../../../header/models/SidebarClassificationNode'
import {IconDisplay} from '../../../../genericComponents/IconDisplay'
import {phraseUrlSearchParamsName} from '../../../SearchParams'

const classificationMap = new Map([
    ['ELECTRONICS', {url: '/images/classification-node-icons/electronics.svg', label:'ELECTRONICS'}],
    ['PROCESSES', {url: '/images/classification-node-icons/processes.svg', label:'PROCESSES'}],
    ['COTS ASSEMBLIES', {url: '/images/classification-node-icons/COTS-Assemblies.svg', label:'COTS ASSEMBLIES'}],
    ['OPTICS', {url: '/images/classification-node-icons/optics.svg', label:'OPTICS'}],
    ['ELECTROMECHANICS', {url: '/images/classification-node-icons/electromechanics.svg', label:'ELECTROMECHANICS'}],
    ['GOODS', {url: '/images/classification-node-icons/goods.svg', label:'GOODS'}],
    ['MECHANICS', {url: '/images/classification-node-icons/mechanics.svg', label:'MECHANICS'}],
    ['PASSIVE HF/RF', {url: '/images/classification-node-icons/passiveHFRF.svg', label:'PASSIVE HF/RF'}],
    ['RAW MATERIALS', {url: '/images/classification-node-icons/raw-materials.svg', label:'RAW MATERIALS'}],
    ['SOFTWARE', {url: '/images/classification-node-icons/software.svg', label:'SOFTWARE'}],
    ['CHEMICAL SUBSTANCES', {url: '/images/classification-node-icons/chemical-substances.svg', label:'CHEMICAL SUBSTANCES'}],
    ['SECURITY ELEMENTS', {url: '/images/classification-node-icons/security-elements.svg', label:'SECURITY ELEMENTS'}],
    ['default', {url: '/images/classification-node-icons/unclassified.svg', label:'default'}]
])

const ClassificationImage = ({technicalClassification}: {technicalClassification: string}) => {
    return (
        <IconDisplay
            className="item-card-image"
            iconName={technicalClassification}
            iconSourceMap={classificationMap}
            iconLabel={`item nature ${technicalClassification}`}
        />
    )
}

const ClassificationCard = ({
    classification,
    numberOfItems,
    classificationTree
}: {
    classification: SidebarClassificationNode
    numberOfItems: number
    classificationTree: SidebarClassificationNode | undefined
}) => {
    const generatePath = useDatxPathGenerator()
    const path = generatePath(ROUTES.searchByClassificationNodeDescendants.path, {classificationId: classification.id})
    const [searchParams] = useSearchParams()
    const topLevelClassification = classificationTree
        ? getPathToClassification(classification.id, classificationTree)[1]
        : null
    const phraseFilter = searchParams.get(phraseUrlSearchParamsName) ?? undefined
    const getUnit = (number: number) => (number <= 1 ? 'item' : 'items')

    const getPath = () => {
        const phraseParam = phraseFilter ? `?${phraseUrlSearchParamsName}=${encodeURIComponent(phraseFilter)}` : ''
        return path + phraseParam
    }

    if (!topLevelClassification) return <></>
    return (
        <Grid size={{xs : 3}}>
            <Card className="classification-filter-card" data-testid="classification-filter-card">
                <Link
                    to={getPath()}
                    className="classification-filter-card-content"
                    data-testid={`classification-filter-card-${classification.id}`}
                >
                    <ClassificationImage technicalClassification={topLevelClassification.label} />
                    <div className="card-content">
                        <Tooltip title={classification.label}>
                            <div className="card-title">{classification.label}</div>
                        </Tooltip>
                        <div className="card-subtitle">
                            <span data-testid="item-count">{numberOfItems}</span> {getUnit(numberOfItems)}
                        </div>
                        <div className="card-caption">{topLevelClassification.label}</div>
                    </div>
                </Link>
            </Card>
        </Grid>
    )
}

export default ClassificationCard
